import { Typography } from '@branch-messenger/willow-ui'
import { FC } from 'react'

import { StyledOrgProfileImage, StyledOrgProfileImageContainer } from './styles'
import { OrgAvatarProps } from './types'

export const OrgAvatar: FC<OrgAvatarProps> = ({ orgName, logoUrl }) => {
  return (
    <StyledOrgProfileImageContainer>
      {logoUrl ? (
        <StyledOrgProfileImage src={logoUrl} alt={orgName} />
      ) : (
        <Typography $bold>{orgName.charAt(0)}</Typography>
      )}
    </StyledOrgProfileImageContainer>
  )
}
